/**
 * Mega Menu Overflow Fix
 * Moves mega menu dropdowns outside of the nav/ul structure on desktop
 * to prevent clipping when overflow: auto is applied to the vertical menu
 */

(function() {
  'use strict';

  // Configuration
  const DESKTOP_BREAKPOINT = 1025; // Matches the CSS breakpoint
  const VERTICAL_MENU_CONTAINER_SELECTOR = '.vertical-menu';
  const VERTICAL_MENU_NAV_SELECTOR = '.header__menu-vertical';
  const MEGA_MENU_ITEM_SELECTOR = '.has-megamenu';
  const MEGA_MENU_SELECTOR = '.menu-dropdown';

  let megaMenuData = [];
  let isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;

  /**
   * Show mega menu
   */
  function showMegaMenu(menuItem, megaMenu, nav) {
    // Calculate position
    const navRect = nav.getBoundingClientRect();
    const menuItemRect = menuItem.getBoundingClientRect();
    const topOffset = menuItemRect.top - navRect.top;

    // Position mega menu
    megaMenu.style.top = topOffset + 'px';

    // Show mega menu
    megaMenu.classList.add('is-visible');
  }

  /**
   * Hide mega menu
   */
  function hideMegaMenu(megaMenu) {
    megaMenu.classList.remove('is-visible');
  }

  /**
   * Move mega menus outside the nav/ul structure
   */
  function moveMegaMenusOut() {
    const verticalMenuContainers = document.querySelectorAll(VERTICAL_MENU_CONTAINER_SELECTOR);

    verticalMenuContainers.forEach(function(container) {
      const nav = container.querySelector(VERTICAL_MENU_NAV_SELECTOR);
      if (!nav) return;

      const megaMenuItems = nav.querySelectorAll(MEGA_MENU_ITEM_SELECTOR);

      megaMenuItems.forEach(function(menuItem, index) {
        const megaMenu = menuItem.querySelector(MEGA_MENU_SELECTOR);

        if (megaMenu && !megaMenu.hasAttribute('data-moved')) {
          // Create unique ID
          const menuId = 'mega-menu-' + Date.now() + '-' + index;

          // Mark menu item and mega menu with matching IDs
          menuItem.setAttribute('data-mega-menu-trigger', menuId);
          megaMenu.setAttribute('data-mega-menu-id', menuId);
          megaMenu.setAttribute('data-moved', 'true');

          // Store reference to original parent
          const originalParent = menuItem;
          megaMenuData.push({
            megaMenu: megaMenu,
            menuItem: menuItem,
            originalParent: originalParent,
            menuId: menuId,
            nav: nav
          });

          // Move mega menu to be a sibling of the nav (inside vertical-menu container)
          // This keeps it outside the nav/ul but inside the vertical-menu wrapper
          container.appendChild(megaMenu);

          // Add CSS class for desktop positioning
          megaMenu.classList.add('mega-menu-desktop-positioned');

          // Add hover event listeners
          menuItem.addEventListener('mouseenter', function() {
            showMegaMenu(menuItem, megaMenu, nav);
          });

          menuItem.addEventListener('mouseleave', function(e) {
            // Check if mouse is moving to the mega menu
            const relatedTarget = e.relatedTarget;
            if (!relatedTarget || (!megaMenu.contains(relatedTarget) && relatedTarget !== megaMenu)) {
              setTimeout(function() {
                if (!megaMenu.matches(':hover')) {
                  hideMegaMenu(megaMenu);
                }
              }, 100);
            }
          });

          // Keep mega menu visible when hovering over it
          megaMenu.addEventListener('mouseenter', function() {
            megaMenu.classList.add('is-visible');
          });

          megaMenu.addEventListener('mouseleave', function() {
            hideMegaMenu(megaMenu);
          });
        }
      });
    });
  }

  /**
   * Restore mega menus to original position (for mobile)
   */
  function moveMegaMenusBack() {
    megaMenuData.forEach(function(data) {
      const megaMenu = data.megaMenu;
      const originalParent = data.originalParent;
      const menuItem = data.menuItem;

      if (megaMenu.hasAttribute('data-moved')) {
        // Remove attributes and classes
        megaMenu.removeAttribute('data-moved');
        megaMenu.removeAttribute('data-mega-menu-id');
        menuItem.removeAttribute('data-mega-menu-trigger');
        megaMenu.classList.remove('mega-menu-desktop-positioned');

        // Move back to original parent (li element)
        originalParent.appendChild(megaMenu);
      }
    });

    // Clear data
    megaMenuData = [];
  }

  /**
   * Handle window resize
   */
  function handleResize() {
    const wasDesktop = isDesktop;
    isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;

    // Desktop to mobile
    if (wasDesktop && !isDesktop) {
      moveMegaMenusBack();
    }
    // Mobile to desktop
    else if (!wasDesktop && isDesktop) {
      // Clear existing data first
      megaMenuData = [];
      moveMegaMenusOut();
    }
  }

  /**
   * Initialize
   */
  function init() {
    if (isDesktop) {
      moveMegaMenusOut();
    }

    // Handle window resize with debounce
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 250);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
